import React, { useContext } from 'react'
import classNames from 'classnames'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { AsP, EyebrowXS, Text } from '@/atoms/Text'
import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/ShowtimesView/components/TheatricalPromotionContext'
import { TexasModalContext } from '@/views/TicketCheckoutViews/ShowtimesView/contexts/TexasModalContext'

interface TlrPremiereDateCardProps {
  onClick?: () => void
}

export const TlrPremiereDateCard: React.FC<TlrPremiereDateCardProps> = () => {
  const texasModalContext = useContext(TexasModalContext)
  const { experiments } = useTheatricalPromotionContext()
  const texasEventLabel = experiments?.['texas-event-label']

  const isMay12OrBefore = () => {
    const today = new Date()
    const may12 = new Date(2025, 4, 12)
    return today <= may12
  }

  if (!isMay12OrBefore()) {
    return null
  }

  const handleClick = () => {
    if (texasModalContext) {
      texasModalContext.openModal()
    }
  }
  return (
    <div
      className="relative h-24 w-[72px] cursor-pointer overflow-hidden rounded-xl border border-[#F45A3B]"
      onClick={handleClick}
    >
      <div
        className="absolute inset-0 bg-white"
        style={{
          background: 'linear-gradient(149.6deg, rgba(244, 90, 59, 0) 0%, rgba(244, 90, 59, 0.1) 100%)',
        }}
      ></div>
      <div className="absolute top-[calc(100%-80px)]">
        <Image src="/v1746148767/the-last-rodeo/Num.webp" alt="" width={68} height={60} />
      </div>
      <FlexColumn className={'relative h-full items-center justify-center'}>
        <div className="relative flex  w-full flex-col items-center justify-center text-center">
          <EyebrowXS weight={'medium'} color={'core-gray-700'} className={'tracking-[1px]'}>
            {texasEventLabel}
          </EyebrowXS>
        </div>

        <div className="relative flex h-[20px] w-full flex-col items-center justify-center text-center">
          <div className="flex  flex-col justify-center pt-0.5 text-center">
            <Text
              as={AsP}
              weight="normal"
              className={classNames(
                '!text-xl !leading-[1.125] !font-nomadic bg-clip-text text-transparent',
                '!bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.25)_100%),linear-gradient(0deg,#F45A3B,#F45A3B)]',
              )}
            >
              Event
            </Text>
          </div>
        </div>
      </FlexColumn>
    </div>
  )
}
